import { createRouter,createWebHashHistory,createWebHistory } from 'vue-router'
import LayoutDefault from "../layout/index.vue";

const routes = [
  {
    path:'/',
    name:'HomeMain',
    component:LayoutDefault,
	redirect: "/",
    meta:{
      iconClass: "iconfont icon-home",
      title: "首页",
    },
	children: [
	  {
	    path: "/",
	    component: () => import("../views/Home/index.vue"),
	    name: "Home",
	    meta: {
	      iconClass: "iconfont icon-home",
	      title: "首页",
	    },
	  },

	]
  }
]

const router = createRouter({
	//createWebHistory = 没有#号
	//createWebHashHistory = 有#号
	history: createWebHistory(),
	routes
})

export default router
